import {Utils} from 'common/scripts/utils';

class FileInput {
    constructor(options) {
        /**
         * Обёртка для инпута файлов
         * @type {HTMLElement}
         */
        this.wrapper = options.wrapper;

        /**
         * Инпут для файлов
         * @type {HTMLElement/null}
         */
        this.input = null;

        /**
         * Блок для вывода списка прикреплённых файлов
         * @type {HTMLElement/null}
         */
        this.listFilesWrapper = null;
    }

    init() {
        this._getElements();
        this._bindEvents();
    }

    _getElements() {
        this.input = this.wrapper.querySelector('.j-file-input-elem');
        this.listFilesWrapper = this.wrapper.querySelector('.j-file-input-list');
    }

    _bindEvents() {
        if (!this.input) {
            return;
        }

        this.input.addEventListener('change', (event) => {
            const file = event.target.files[0];

            Utils.clearHtml(this.listFilesWrapper);

            const template = `<li>
                        <span>${file.name}</span>
                        <button class="j-file-remove"></button>
                    </li>`;

            Utils.insetContent(this.listFilesWrapper, template);

            const removeButton = this.listFilesWrapper.querySelector('.j-file-remove');

            removeButton.addEventListener('click', (removeEvent) => {
                removeEvent.preventDefault();

                this.input.value = null;

                removeButton.parentNode.remove();
            });
        });
    }
}

export default FileInput;
